<div
  [formGroup]="form"
  [patchForm]="configFormValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isOgoneCollapsed ? 'false' : 'true'"
          (click)="toggleOgoneCollapsed()"
          aria-controls="ogone"
        >
          <span class="fs-3"> {{ 'paymentModule.ogone' | translate }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isOgoneCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isOgoneCollapsed" class="card-body" id="ogone">
      <div class="mb-4">
        <label class="form-label">{{
          'paymentModule.ogoneURL' | translate
        }}</label>

        <div class="input-group">
          <input
            type="text"
            id=""
            class="form-control"
            aria-describedby="ogone url"
            formControlName="ogoneurl"
            placeholder="https://example.com"
          />
        </div>
      </div>
      <div class="mb-4">
        <label class="form-label">{{
          'paymentModule.salesPersonId' | translate
        }}</label>

        <input
          type="number"
          class="form-control"
          formControlName="sales_person"
        />
      </div>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="button"
          (click)="onSubmit(['ogoneurl', 'sales_person'])"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
  <!-- End Card -->

  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="
            isAllowedPaymentMethodsCollapsed ? 'false' : 'true'
          "
          (click)="
            isAllowedPaymentMethodsCollapsed = !isAllowedPaymentMethodsCollapsed
          "
          aria-controls="allowed-payment-methods"
        >
          <span class="fs-3">
            {{ 'configurationOptionModule.allowedPaymentMethods' | translate }}
          </span>
          <i
            class="fa fa-fw"
            [ngClass]="
              isAllowedPaymentMethodsCollapsed
                ? 'fa-chevron-down'
                : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <div
      *ngIf="!isAllowedPaymentMethodsCollapsed"
      class="card-body"
      id="allowed-payment-methods"
    >
      <fieldset class="mb-4">
        <legend class="visually-hidden">{{
          'configurationOptionModule.allowedPaymentMethods' | translate
        }}</legend>
        <p class="small text-muted mb-2">
          {{
            'configurationOptionModule.allowedPaymentMethodsHelp' | translate
          }}
        </p>
        <div class="row g-2">
          <div
            class="col-12 col-sm-6 col-lg-4"
            *ngFor="let payMethodOption of activeAllowedPayMethodOptions"
          >
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'active-allowed-pay-method-' + payMethodOption.value"
                [checked]="
                  form.value[
                    configOptionKeys.ACTIVE_ALLOWED_PAY_METHODS
                  ].includes(payMethodOption.value)
                "
                (change)="
                  onActiveAllowedPayMethodChange(
                    payMethodOption.value,
                    $event
                  )
                "
              />
              <label
                class="form-check-label"
                [for]="'active-allowed-pay-method-' + payMethodOption.value"
              >
                {{
                  'saleModule.payMethodType' + payMethodOption.value
                    | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="button"
          (click)="onSubmit([configOptionKeys.ACTIVE_ALLOWED_PAY_METHODS])"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>

  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isPaymentBrandsCollapsed ? 'false' : 'true'"
          (click)="isPaymentBrandsCollapsed = !isPaymentBrandsCollapsed"
          aria-controls="checkout-payment-brands"
        >
          <span class="fs-3">
            {{ 'configurationOptionModule.checkoutPaymentBrands' | translate }}
          </span>
          <i
            class="fa fa-fw"
            [ngClass]="
              isPaymentBrandsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <div
      *ngIf="!isPaymentBrandsCollapsed"
      class="card-body"
      id="checkout-payment-brands"
    >
      <fieldset class="mb-4">
        <legend class="visually-hidden">{{
          'configurationOptionModule.checkoutPaymentBrands' | translate
        }}</legend>
        <p class="small text-muted mb-2">
          {{
            'configurationOptionModule.checkoutPaymentBrandsHelp' | translate
          }}
        </p>
        <div class="row g-2">
          <div
            class="col-12 col-sm-6 col-lg-4"
            *ngFor="let paymentBrandOption of paymentBrandOptions"
          >
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'checkout-payment-brand-' + paymentBrandOption.id"
                [checked]="
                  form.value[
                    configOptionKeys.CHECKOUT_PAYMENT_BRANDS
                  ].includes(paymentBrandOption.id)
                "
                (change)="
                  onPaymentBrandChange(paymentBrandOption.id, $event)
                "
              />
              <label
                class="form-check-label"
                [for]="'checkout-payment-brand-' + paymentBrandOption.id"
              >
                {{ paymentBrandOption.label }}
              </label>
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="button"
          (click)="onSubmit([configOptionKeys.CHECKOUT_PAYMENT_BRANDS])"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</div>
